<template>
  <div class="mt-3">
    <b-table
      id="generalTable"
      ref="generalTables"
      :current-page="0"
      :fields="fields"
      :filter="filter"
      :filter-included-fields="activatedFilter"
      :items="data"
      :per-page="0"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      class="dm-paginated-table"
      show-empty
      small
      striped
      :responsive="responsive"
      :head-variant="headVariant"
      :busy="isBusy"
      :tbody-tr-class="tbodyTrClass"
      @filtered="filtered"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle" variant="primary" label="Spinning" />
        </div>
      </template>

      <template v-slot:cell(actions)="row">
        <div class="dm-paginated-table-actions">
          <slot :row="row" name="image" />
          <slot :row="row" name="action" />

          <b-button
            v-if="
              showActionButtons &&
              showUpdateButtom &&
              (!verifyAdminUser ||
                !row.item.createdByAdmin ||
                userProfile === 'admin_sistema' ||
                isMaster)
            "
            v-b-tooltip.hover="{
              fallbackPlacement: 'clockwise',
              title: $t('editar')
            }"
            class="mr-1 mb-1"
            size="sm"
            variant="outline-primary"
            @click="info(row.item)"
          >
            <b-icon icon="pencil" variant="primary" />
          </b-button>
          <b-button
            v-if="
              showActionButtons &&
              showDeleteButtom &&
              (!verifyAdminUser ||
                !row.item.createdByAdmin ||
                userProfile === 'admin_sistema' ||
                isMaster)
            "
            v-b-tooltip.hover="{
              fallbackPlacement: 'clockwise',
              title: $t('excluir')
            }"
            class="mr-1 mb-1"
            size="sm"
            variant="outline-danger"
            @click="remove(row.item._id)"
          >
            <b-icon icon="trash" variant="danger" />
          </b-button>
        </div>
      </template>

      <slot name="overrideActions" />

      <template v-slot:empty>
        <div class="text-center">
          {{ $t('semregistros') }}
        </div>
      </template>

      <template
        v-for="slotName in Object.keys($scopedSlots)"
        v-slot:[slotName]="slotScope"
      >
        <slot :name="slotName" v-bind="slotScope" />
      </template>
    </b-table>

    <b-col v-if="showPagination" class="my-1" md="12" sm="6">
      <b-pagination
        v-model="localPage"
        :per-page="localLimit"
        :total-rows="localTotalRows"
        align="center"
        aria-controls="generalTable"
        class="my-0"
        size="sm"
        @input="get"
      />
    </b-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DMPaginatedTable',

  props: {
    tbodyTrClass: {
      type: Function,
      default: () => {}
    },
    fields: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    tabIndex: {
      type: Number,
      default: () => null
    },
    currentIndex: {
      type: Number,
      default: () => null
    },
    showPagination: {
      type: Boolean,
      default: () => true
    },
    responsive: { type: Boolean, default: true },
    headVariant: { type: String, default: null },
    totalRows: { type: Number, default: 1 },
    page: { type: Number, default: 1 },
    limit: { type: Number, default: 20 },
    verifyAdminUser: { type: Boolean, default: false },
    showActionButtons: { type: Boolean, default: true },
    showUpdateButtom: { type: Boolean, default: true },
    showDeleteButtom: { type: Boolean, default: true },
    titleModalGuests: { type: String, default: 'convidadosExternos' },
    isBusy: { type: Boolean, default: () => false }
  },
  data() {
    return {
      localTotalRows: 1,
      id: null,
      localPage: 1,
      localLimit: 20,
      pageOptions: [5, 10, 15],
      sortBy: 'nome', // computed
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      activatedFilter: []
    }
  },
  computed: mapGetters(['userProfile', 'isMaster']),
  watch: {
    currentIndex: function () {
      if (
        this.tabIndex != null &&
        this.currentIndex != null &&
        this.tabIndex === this.currentIndex
      ) {
        this.get()
      }
    },
    page() {
      this.localPage = this.page
    },
    limit() {
      this.localLimit = this.limit
    },
    totalRows() {
      this.localTotalRows = this.totalRows
    }
  },
  created() {
    if (
      this.tabIndex != null &&
      this.currentIndex != null &&
      this.tabIndex === this.currentIndex
    ) {
      this.get()
    }

    this.localTotalRows = this.totalRows
    this.localPage = this.page
    this.localLimit = this.limit
  },
  methods: {
    filtered(filteredItems) {
      this.localPage = 1
      this.localTotalRows = filteredItems.length
      this.get()
    },
    get() {
      const parameters = {
        limit: this.localLimit,
        page: this.localPage
      }
      this.$emit('get', parameters)
    },
    info(item) {
      this.$emit('update', item)
    },
    remove(id) {
      this.$emit('remove', id)
    }
  }
}
</script>

<style lang="scss" scoped>
.dm-paginated-table-actions {
  display: flex;
  justify-content: center;
}

.dm-paginated-table {
  font-size: 16px;
}

::v-deep .table-sm th,
::v-deep .table-sm td {
  vertical-align: middle !important;
}
</style>
